import { IMenuModule, IMenuItem, IMenuMatchItem, IApplicationMenuItem } from 'src/types/module_types_menu';
import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';

import navigation from'../../../pip/library/pi-navigation/pi-navigation.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export interface IMenuModuleConfiguration extends IModuleConfiguration {
  configurations: {
    menu: string;
  };
}

export class MenuModule extends ModuleConfiguration {
  configuration: IMenuModuleConfiguration;
  menu: IMenuModule;

  initialize(configuration: IMenuModuleConfiguration) {
    return new Promise((resolve) => {
      this.configuration = this.__defaultConfiguration(configuration);

      fetch(navigation.uri.write(this.configuration.configurations.menu))
        .then((response) => response.json())
        .then((menu) => {
          menu = 'data' in menu ? menu.data : menu;

          const navigationItems = menu.navigation_items || menu.navigation_menus || {};

          (navigationItems.application || []).forEach((menuItem: IMenuItem) => this.__buildUpURI(menuItem));
          (navigationItems.account || []).forEach((menuItem: IMenuItem) => this.__buildUpURI(menuItem));

          this.menu = menu;
        })
        .then(() => resolve(configuration));
    });
  }

  private __defaultConfiguration(configuration: IMenuModuleConfiguration) {
    return f1.merge(
      'over',
      {
        configurations: {
          menu: '@platform/menu.json'
        }
      },
      configuration
    ) as IMenuModuleConfiguration;
  }

  private __buildUpURI(root: IMenuItem, baseUri = '') {
    const _baseUri = (root.uri = `${baseUri}${root.uri}`);

    if ((root as IApplicationMenuItem).active_state == null) {
      (root as IApplicationMenuItem).active_state = [root.uri];
    }

    if (root.image != null) {
      root.image = navigation.uri.write(root.image);
    }

    (root.navigation_items || root.children || []).forEach((menuItem) => this.__buildUpURI(menuItem, _baseUri));
    return root;
  }

  getActiveResource(routingItems: IMenuItem[], rootURI: string): IMenuItem {
    return f1.read('/0/navResource', {} as IMenuItem, this.getActiveResources(routingItems, rootURI));
  }

  getActiveResources(routingItems: IMenuItem[], rootURI: string) {
    return routingItems
      .map(
        (navResource): IMenuMatchItem => {
          const match = rootURI.indexOf(navResource.uri) >= 0 ? navResource.uri.length : -1;

          return {
            navResource,
            match
          };
        }
      )
      .filter((o) => o.match !== -1)
      .sort((a: IMenuMatchItem, b: IMenuMatchItem) => a.match - b.match);
  }

  /**
   * make sure URI is:
   * 1. relative
   * 2. a string
   * @param uri
   */
  normalizeURI(uri: string) {
    const _uri = (uri || '') + '';

    return _uri.indexOf('http') === 0 ? _uri : _uri.indexOf('#') === 0 ? _uri : `#${_uri}`;
  }
}
